import component from './enrollee-student-breadcrumbs'

export default component
